const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';
import {Modal} from "bootstrap";

//require('./utilities/class_enlarge.js');
//require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
require('./utilities/pdw_gsap.js');
//require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
//require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
require('./utilities/pdw_aos.js');
//require('./utilities/pdw_woocommerce.js');

document.addEventListener("DOMContentLoaded", function () {
    let lirePlusBtn = document.getElementById('lire-plus');
    let texteExtrait = document.getElementById('texte-extrait');
    let texteComplet = document.getElementById('texte-complet');

    if (lirePlusBtn) {
        lirePlusBtn.addEventListener('click', function () {
            texteExtrait.style.display = 'none';
            texteComplet.style.display = 'block';
            lirePlusBtn.style.display = 'none';
        });
    }
    document.querySelectorAll('.room-icon').forEach(function (icon) {
        if (icon) {
            let maskUrl = icon.style.mask;

            icon.style.setProperty('--mask-url', maskUrl);
        }
    });
    if (document.querySelector('.pdw-gallery-1')) {
        document.getElementById('show_image').addEventListener('click', (e) => {
            document.querySelector('.pdw-gallery-1').click();
        });
    }

    if (document.querySelector('.accordion-item')) {
        document.querySelectorAll('.accordion-item').forEach((accordion) => {
            accordion.addEventListener('click', () => {
                if (accordion.classList.contains('show')) {
                    accordion.classList.remove('show');
                } else {
                    document.querySelectorAll('.accordion-item.show').forEach((openAccordion) => {
                        openAccordion.classList.remove('show');
                    });
                    accordion.classList.add('show');
                }
            });
        });
    }
});
